import { styled } from 'styled-components';

export const Title = styled.span`
  color: #000;
  font-feature-settings: 'case' on;
  font-family: Playfair Display;
  user-select: none;
  font-size: 33px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const SubTitle = styled.span`
  color: #000;
  width: 353px;
  font-feature-settings: 'case' on;
  user-select: none;
  font-family: Playfair Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
export const UnderlineText = styled.span`
  color: #1b1b1b;

  user-select: none;
  font-size: 16px;
  font-family: 'Poppins-Medium';
  font-style: normal;
  line-height: normal;
  align-self: flex-end;
  cursor: ${props => (props.$timer ? 'pointer' : 'not-allowed')};
  letter-spacing: -0.2px;
  text-decoration-line: underline;
  &:active {
    opacity: ${props => (props.$timer ? 0.55 : 1)};
  }
`;
export const StyledText = styled(UnderlineText)`
  text-decoration: none;
  opacity: ${props => (props.$timer ? 0 : 1)};
  cursor: default;
  &:active {
    opacity: 1;
  }
`;
export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
`;

export const Text = styled.span`
  color: #000;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';
  user-select: none;
  line-height: normal;
  letter-spacing: -0.2px;
  opacity: 0.5;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
  min-width: 380px;
  min-height: 567px;

  width: 100%;
  @media (max-width: 485px) {
    min-width: 100%;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Back = styled.div`
  width: fit-content;
  cursor: pointer;
  padding: 0px 6.5px;
  &:active {
    opacity: 0.55;
  }
`;
